import React from "react";
import axios from "axios";
import { Button } from "@mui/material";

const SubscribeButton = ({ style }) => {
  const createCheckoutSession = async () => {
    try {
      // Create checkout session on the server
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-checkout-session`
      );

      // Redirect user to the Stripe Checkout page
      const sessionId = response.data.id;
      const stripe = window.Stripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
      stripe.redirectToCheckout({ sessionId });
    } catch (error) {
      console.error("Error creating checkout session:", error);
    }
  };

  return (
    <Button
      style={style}
      variant="contained"
      // color="primary"
      onClick={createCheckoutSession}
    >
      Subscribe
    </Button>
  );
};

export default SubscribeButton;
